/**
 * @generated SignedSource<<e68da9730441e567735b58030ad67ab1>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "SetPasswordLoginUsernamePayload",
            "kind": "LinkedField",
            "name": "setPasswordLoginUsername",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newUsername",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserUsernameUpdateModal_setPasswordLoginUsernameMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserUsernameUpdateModal_setPasswordLoginUsernameMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "2ccbf979e240bc83adaef6ef092e88d7",
            "id": null,
            "metadata": {},
            "name": "UserUsernameUpdateModal_setPasswordLoginUsernameMutation",
            "operationKind": "mutation",
            "text": "mutation UserUsernameUpdateModal_setPasswordLoginUsernameMutation(\n  $model: SetPasswordLoginUsernameInput!\n) {\n  setPasswordLoginUsername(model: $model) {\n    newUsername\n  }\n}\n"
        }
    };
})();
node.hash = "afeb22ae84d40f09274a0d853b535749";
export default node;
